import { Badge } from "react-bootstrap";
import type { ReconciliationCardSummary } from "./reconciliationGridTypes";

export interface ReconciliationCardSummaryBadgesProps {
    summary: ReconciliationCardSummary;
}

function formatCountLabel(count: number, singular: string, plural: string): string {
    return `${count} ${count === 1 ? singular : plural}`;
}

export function ReconciliationCardSummaryBadges({ summary }: ReconciliationCardSummaryBadgesProps) {
    const {
        alignedCount,
        needsChangesCount,
        toAddCount,
        toUpdateCount,
        toReactivateCount,
        toRestoreCount,
        toRemoveCount,
    } = summary;

    return (
        <>
            <Badge bg={alignedCount > 0 ? "success" : "secondary"}>
                {formatCountLabel(alignedCount, "already aligned", "already aligned")}
            </Badge>
            {needsChangesCount > 0 && (
                <Badge bg="warning" text="dark">
                    {formatCountLabel(needsChangesCount, "need change", "need changes")}
                </Badge>
            )}
            {toAddCount > 0 && (
                <Badge bg="info">{formatCountLabel(toAddCount, "to add", "to add")}</Badge>
            )}
            {toUpdateCount > 0 && (
                <Badge bg="warning" text="dark">
                    {formatCountLabel(toUpdateCount, "to update", "to update")}
                </Badge>
            )}
            {toReactivateCount > 0 && (
                <Badge bg="warning" text="dark">
                    {formatCountLabel(toReactivateCount, "to reactivate", "to reactivate")}
                </Badge>
            )}
            {toRestoreCount > 0 && (
                <Badge bg="danger">{formatCountLabel(toRestoreCount, "to restore", "to restore")}</Badge>
            )}
            {toRemoveCount > 0 && (
                <Badge bg="secondary">{formatCountLabel(toRemoveCount, "to remove", "to remove")}</Badge>
            )}
        </>
    );
}
